// extracted by mini-css-extract-plugin
export default {"modal":"qCjYe7","title":"PnO647"};